import styled from 'styled-components';

export const Container = styled.div`
  margin: 15px;

  p {
    font-size: 1.8rem;
    margin-bottom: 15px;
  }
`;
